import ModelProxy from "../model-proxy";
import {EntityType} from "../../gd/const/item";
import ModelEntity from "../model-entity";
import {ReminderType} from "./const";
import ErrorProto from "../../gd/validation/error";
import ErrorFieldRequired from "../../gd/validation/error-field-required";
import ReminderFields from "./fields";

const debug = false
// const debug = "EventBaseModel"


// !!!!! SEE
// SessionReminderModel
// !!!!

export default class Reminder extends ModelEntity {

    public id                   : ID
    public userId               : ID
    public title                : string
    public reminderType         : ReminderType
    public date                 : Moment | null = null // currently is used in TaskReminderModal only
    public momentCreated        : Moment

    // public itemType             : number


    // self._companyId         = self.initValue('companyId', info)
    // self._createdByUserId   = self.initValue('createdByUserId', info)
    // self._isArchived        = self.initValue('isArchived', info)
    // self._scheduleStatus    = self.initValue('scheduleStatus', info)
    // self._scheduleDate      = self.initValue('scheduleDate', info)
    // self._scheduleMoment    = self.initValue('scheduleMoment', info)
    // self._descriptionTxt    = self.initValue('descriptionTxt', info)
    // self._descriptionRtf    = self.initValue('descriptionRtf', info)
    // self._properties        = self.initValue('properties', info)    # would be good to use class here... but i dont' remember all params at the moment
    // self._actionItems       = self.initValue('actionItems', info)
    // self._recurrencyId      = self.initValue('recurrencyId', info)



    constructor(data:any, useProxy = true) {
        super(data['id'], EntityType.REMINDER)

        this.id             = data.id
        this.userId         = data.userId
        this.title          = data.title
        this.reminderType   = data.reminderType
        this.momentCreated  = data.momentCreated

        return useProxy ? new Proxy(this, ModelProxy) : this;
    }

    validate():ErrorProto[] | null  {
        const errors : any[] = []
        const fields = new ReminderFields()

        if (_.isEmpty(this.title)) errors.push(new ErrorFieldRequired(fields.title))
        if (!this.userId) errors.push(new ErrorFieldRequired(fields.userId))

        if (_.isEmpty(errors)) return null
        else return errors
    }

    toJSON() {
        console.warn("Not implmented yet")
        return "not implemented"
    }
}



